import { render, staticRenderFns } from "./SuiteTemplates.vue?vue&type=template&id=653e2c2c&"
import script from "./SuiteTemplates.vue?vue&type=script&lang=js&"
export * from "./SuiteTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports